import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

type Result = ModelHookResult<
	undefined,
	{
		handleDmProfileLinkClick: (dmId: string) => Promise<void>;
	}
>;

export function useLoadedDecisionMakerListItem(): Result {
	const track = useTracking();

	const handleDmProfileLinkClick = useCallback(
		async (decisionMakerId: string) => {
			await track('decision_maker_profile_link_click', {
				decision_maker_id: decisionMakerId,
				source_location: 'petition_details',
			});
		},
		[track],
	);

	return {
		actions: {
			handleDmProfileLinkClick,
		},
	};
}
